import { Component, HostBinding, Input } from '@angular/core';


@Component({
    selector: 'cmp-side-card',
    templateUrl: './side-card.component.html',
    styles: [],
    standalone: true,
    imports: [],
})
export class SideCardComponent {
  @HostBinding('class') class = ['side-card'];
  @Input() faClass;
  @Input() cardTitle: string;
  @Input() noTitleMargin = false;
}
